// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import '../src/styles/app.scss';
import JsonViewer from 'vue-json-viewer';
import {library} from '@fortawesome/fontawesome-svg-core';
import {
  faBan,
  faCalendarMinus,
  faCheck,
  faCheckCircle,
  faClipboard,
  faCodeBranch,
  faCogs,
  faEdit,
  faFlask,
  faHourglassHalf,
  faInfoCircle,
  faTractor,
  faTrashAlt,
  faRedoAlt,
  faLock,
  faBoxes,
} from '@fortawesome/free-solid-svg-icons';
import {faGithub} from '@fortawesome/free-brands-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';
import AsyncComputed from 'vue-async-computed';

library.add(faBan);
library.add(faCalendarMinus);
library.add(faCheck);
library.add(faCheckCircle);
library.add(faClipboard);
library.add(faCodeBranch);
library.add(faCogs);
library.add(faEdit);
library.add(faFlask);
library.add(faGithub);
library.add(faHourglassHalf);
library.add(faInfoCircle);
library.add(faTrashAlt);
library.add(faTractor);
library.add(faRedoAlt);
library.add(faLock);
library.add(faBoxes);

// Using kebab case per the suggested usage and examples: https://www.npmjs.com/package/@fortawesome/vue-fontawesome
Vue.component('font-awesome-icon', FontAwesomeIcon); // eslint-disable-line vue/component-definition-name-casing

Vue.use(BootstrapVue);
Vue.use(JsonViewer);
Vue.use(AsyncComputed);
Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {App},
  template: '<App/>',
});
